import * as React from "react";
import Nav from "./nav/nav";
import Footer from "./footer/footer";

const Layout = ({ children }) => {
  return (
    <>
      <Nav />
      <main>{children}</main>
      <Footer />
    </>
  );
};

export default Layout;
